module.exports = __webpack_public_path__ + "static/img/logo.5d3b10a7.png";